import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import LegislatorsActions from '../../../../actions/legislators';
import { getLegislators } from '../../../../selectors/legislators';
import ActivityList from '../../../ActivitiesPage/ActivityList';
import ActionHandler from '../../../ActionHandler';
import OnboardingNavigation from '../../OnboardingNavigation';
import { StepHeader } from '../index';
import styles from './RepresentativeList.css';

class RepresentativeList extends React.Component {
  static propTypes = {
    pageColor: PropTypes.shape({
      value: PropTypes.string,
      name: PropTypes.string,
    }),
    toggleView: PropTypes.func,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    legislators: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.shape({
      legislators: PropTypes.object,
    }),
  };
  state = {
    errors: [],
  };

  convertLegislatorToTile = legislator => {
    const { id, personalDetails, profile } = legislator;
    const { webMediaUrls } = profile || {};
    const { title, firstName, lastName } = personalDetails || {};
    const image =
      ((webMediaUrls || []).find(
        url => (url.type || '').toLowerCase() === 'photo'
      ) || {}
      ).url || undefined;
    const name = `${firstName || ''} ${lastName || ''}`.trim();

    return {
      id,
      color: this.props.pageColor.name,
      image,
      icon: 'person',
      details: {
        title: {
          value: title || '',
          className: styles.repTitle,
        },
        name: {
          value: name,
          className: styles.repName,
        },
      },
    };
  };

   render() {
    const {
      pageColor,
      legislators,
      actions,
      isLoading,
      error,
      toggleView,
    } = this.props;
  
    const displayLoadingMessage = (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
        <ProgressBar type="circular" mode="indeterminate" multicolor />
      </div>
    );
  var displayErrorMessage = "We couldn't find any representatives for this address. Please make sure your home address is entered correctly if you would like to see your representatives.";
    
    return (
      <div>
        <StepHeader>
          NFIB Members have a direct link to their representatives. Here are
          yours!
        </StepHeader>
        <ActionHandler
          condition={!legislators || !legislators.length}
          action={actions.legislators.get}
        />
        <div className={styles.activityList}>
          <ActivityList
            mobileIcon
            isLoading={isLoading}
            activities={(legislators || []).map(this.convertLegislatorToTile)}
            color={pageColor.name}
            loadingMessage={displayLoadingMessage}
            noDataMessage={displayErrorMessage}
          />
        </div>
        <OnboardingNavigation
          {...this.props}
          goBack={() => toggleView('HomeAddress')}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const legislators = getLegislators(state);
  const hasNoData = !legislators || legislators.length === 0;
  const isLoadingPromises = state.loadingPromises.includePromises && state.loadingPromises.includePromises.length > 0;
  
  return {
    legislators: legislators,
    isLoading: hasNoData && isLoadingPromises, // Loading if no data AND promises exist
    error: null, // You might need to check for errors differently
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      legislators: bindActionCreators(LegislatorsActions, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RepresentativeList);



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/Representatives/RepresentativeList.js